import { Link } from 'react-router-dom';
import { works } from '@/mocks/films';
import { stars } from '@/mocks/stars';

const stats = [
  { label: '收录作品', value: works.length, suffix: '部' },
  { label: '电影', value: works.filter((w) => w.type === 'movie').length, suffix: '部' },
  { label: '电视剧', value: works.filter((w) => w.type === 'tv').length, suffix: '部' },
  { label: '明星动态', value: stars.length, suffix: '位' },
];

export default function SiteIntro() {
  return (
    <section className="w-full bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-10 md:px-8 md:py-14">
        <div className="grid grid-cols-1 items-center gap-8 lg:grid-cols-2 lg:gap-12">
          <div className="relative h-64 w-full overflow-hidden rounded-lg border border-background-200 md:h-80">
            <img
              src="https://readdy.ai/api/search-image?query=artistic%20flat%20lay%20of%20film%20reels%2C%20popcorn%2C%20notebooks%20and%20a%20camera%20on%20a%20warm%20wooden%20table%2C%20soft%20natural%20light%2C%20cozy%20editorial%20still%20life%20with%20amber%20and%20cream%20tones%20without%20text&width=1200&height=800&seq=home-intro&orientation=landscape"
              alt="无颜的月影视内容站"
              title="无颜的月 影视资讯与剧情介绍平台"
              className="h-full w-full object-top"
            />
          </div>

          <div>
            <span className="inline-flex items-center gap-1 rounded-full bg-primary-50 px-3 py-1 text-xs font-medium text-primary-600">
              <i className="ri-information-line" />
              关于无颜的月
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              专注影视资讯与剧情介绍的内容平台
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600 md:text-base">
              无颜的月面向广大影视爱好者与追剧观众，聚合最新影视资讯、详细剧情介绍与明星动态，覆盖电影与电视剧资源。我们希望用清晰的信息层级与流畅的浏览体验，帮你快速找到想看的作品，读懂每一段故事。
            </p>
            <div className="mt-6 grid grid-cols-2 gap-4 sm:grid-cols-4">
              {stats.map((s) => (
                <div key={s.label} className="rounded-lg border border-background-200 bg-background-100 p-3 text-center">
                  <p className="font-heading text-xl font-bold text-primary-600">
                    {s.value}
                    <span className="ml-0.5 text-xs font-normal text-foreground-500">{s.suffix}</span>
                  </p>
                  <p className="mt-1 text-xs text-foreground-500">{s.label}</p>
                </div>
              ))}
            </div>
            <Link
              to="/about"
              className="mt-6 inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 whitespace-nowrap"
            >
              了解我们
              <i className="ri-arrow-right-line" />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}